import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSortable } from "react-sortablejs";
import { FormikErrors } from "formik";
import { Col, Input, Label } from "reactstrap";
import ModalConfirm from "./ModalConfirm";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import { IParams } from "api/types/_params";
import { AGENCY_CUSTOM_PARAM_CHANNEL_OPTION } from "helpers/constans";
import DropdownOptionNew from "./DropdownOptionNew";
import TooltipCustom from "./TooltipCustom";

interface CustomParametersFormProps {
  formik: any
}

const PARAM_DEFAULT = {
  param_key: "",
  param_value: "",
  description: "",
  status: 1,
  ordering: 1,
  id: 1
};

const CustomParametersForm = ({
  formik = ""
}: CustomParametersFormProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const handleChangeSort = (data: IParams[]) => {
    const formatData = data?.map((item, index) => ({
      ordering: index + 1,
      param_key: item?.param_key,
      param_value: item?.param_value,
      description: item?.description,
      status: item?.status,
      id: item?.id
    }));

    formik.setFieldValue("params", formatData);
  };

  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  const handleAddItem = () => {
    formik.setFieldValue("params", [
      ...formik?.values?.params,
      { ...PARAM_DEFAULT, id: formik?.values?.params?.length + 1, ordering: formik?.values?.params?.length + 1 },
    ]);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = formik?.values?.params.filter(
      (_: any, i: any) => i !== index
    );
    formik.setFieldValue("params", updatedItems);
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          <Label htmlFor="titleKoreaInput" className="form-label">
            {t("Custom Parameters")} <span className="text-danger"></span>
            {
              <TooltipCustom
                title={`${t('Google Ads Tracking : key = channel, value = google')} <br/> ${t('Meta Ads tracking : key = channel, value = meta')}`}
                className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                style={{ transform: 'translateY(2px)' }}
              >
                <i className="ri-question-line align-bottom text-secondary" ></i>
              </TooltipCustom>
            }
          </Label>

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                <th style={{ minWidth: 25 }}></th>
                <th>{t("Status")}</th>
                <th>{t("Key")}</th>
                <th>{t("Value")}</th>
                <th>{t("Description")}</th>
                <th>{t("")}</th>
              </tr>
            </thead>
            <ReactSortable
              animation={200}
              delay={2}
              tag={"tbody"}
              filter={".locked_item"}
              preventOnFilter={false}
              list={formik?.values?.params as IParams[]}
              setList={handleChangeSort}
              onMove={(evt) => !evt.related.classList.contains("locked_item")}
              handle={".my-handle"}
            >
              {formik?.values?.params?.map((item: any, index: number) => {
                return (
                  <tr key={`${item?.id}`} >
                    <td
                      className="my-handle text-center"
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {" "}
                      <i className="ri-menu-line"></i>
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        className="form-check form-switch form-switch-sm text-center"
                        dir="ltr"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name={`params.${index}.status`}
                          checked={item?.status === 1 ? true : false}
                          onChange={(e) => {
                            // console.log(e);

                            formik.setFieldValue(
                              `params.${index}.status`,
                              e?.target?.checked === true ? 1 : 2
                            );
                          }}
                        />
                      </div>
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "baseline",
                      }}
                    >
                      <Input
                        name={`params.${index}.param_key`}
                        type="text"
                        className="form-control"
                        placeholder={t("Please enter the key")}
                        max={16}
                        value={item?.param_key}
                        onBlur={(event) => {
                          formik.handleBlur(event);
                        }}
                        onChange={(event) => {
                          formik.setFieldValue(
                            `params.${index}.param_key`,
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.errors.params &&
                      (formik.errors.params[index] as FormikErrors<IParams>)
                        ?.param_key ? (
                        <small className="text-danger mt-2">
                          {
                            (
                              formik.errors.params[
                                index
                              ] as FormikErrors<IParams>
                            )?.param_key
                          }
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "baseline",
                        maxWidth: "340px",
                        width: "340px"
                      }}
                    >
                      {
                        (item?.param_key === 'channel') ? (
                            <div style={{minWidth: 304, width: "100%"}}>
                            <DropdownOptionNew
                              name={`params.${index}.param_value`}
                              dataList={AGENCY_CUSTOM_PARAM_CHANNEL_OPTION || []}
                              placeholder={`${t("Select channel")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={item?.param_value}
                              onChangeSelect={(event: any) => {
                                formik.setFieldValue(
                                  `params.${index}.param_value`,
                                  event?.value
                                );
                              }}
                              isHasOptionAll={false}
                              lstImage={true}
                              hideSelectedOptions={false}
                            />
                          </div>
                        ) : (
                          <Input
                            name={`params.${index}.param_value`}
                            type="text"
                            className="form-control"
                            placeholder={t("Please enter the value")}
                            max={16}
                            value={item?.param_value}
                            onChange={(event) => {
                              formik.setFieldValue(
                                `params.${index}.param_value`,
                                event?.target?.value
                              );
                            }}
                          />
                        )
                      }
                      {formik.errors.params &&
                      (formik.touched.params?.[index] as FormikErrors<IParams>)
                        ?.param_value &&
                      (formik.errors.params[index] as FormikErrors<IParams>)
                        ?.param_value ? (
                        <small className="text-danger mt-2">
                          {
                            (
                              formik.errors.params[
                                index
                              ] as FormikErrors<IParams>
                            )?.param_value
                          }
                        </small>
                      ) : null}
                    </td>
                    <td style={{ verticalAlign: "baseline" }}>
                      <textarea
                        className="form-control"
                        name={`params.${index}.description`}
                        value={item?.description}
                        placeholder={`${t("Please enter the description")}...`}
                        onChange={(event) => {
                          formik.setFieldValue(
                            `params.${index}.description`,
                            event?.target?.value
                          );
                        }}
                        style={{ height: 40 }}
                      />
                    </td>
                    <td>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div>
                          {
                            <div
                              className="text-danger cursor-pointer"
                              onClick={() => {
                                setIsOpenConfirm(true);
                                setIndexDelete(index);
                              }}
                            >
                              <i className="ri-delete-bin-3-fill align-bottom"></i>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </ReactSortable>
          </table>
        </Col>

        <Col lg={12} className="mb-5">
          <div
            className="text-primary text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2"
            style={{ fontSize: 30, background: "#0bcee91c" }}
            onClick={handleAddItem}
          >
            + <span style={{ fontSize: 14 }}>{t("Add Parameters")}</span>
          </div>
        </Col>
      </>

      <ModalConfirm
        header={t("Delete this param")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionDelete}
      />
    </React.Fragment>
  );
};

export default CustomParametersForm;
